import { render } from "./smsTemplate.vue?vue&type=template&id=07fb1e04&scoped=true"
import script from "./smsTemplate.vue?vue&type=script&lang=js"
export * from "./smsTemplate.vue?vue&type=script&lang=js"

import "./smsTemplate.vue?vue&type=style&index=0&id=07fb1e04&lang=scss&scoped=true"
import "./smsTemplate.vue?vue&type=style&index=1&id=07fb1e04&lang=css"

import exportComponent from "D:\\workCode\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fb1e04"]])

export default __exports__